export default "https://cdn-static.gokick.com/assets/6e728f413af15b4cc1be7e84aa96f9132e166160/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";